import styled from "styled-components";
import { responsive } from "../../styles/constants.style";

export const ExpandCollapseButtonWrapper = styled.div`
  .header-collapse {
    margin: 16px 16px 16px 16px;
    text-align: end;
    ${responsive.MOBILE`
      margin: 0 16px 0 0;  
    `}
  }
`;
